import { createFileRoute, redirect } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import {
  buildOidcLoginUrlForPath,
  buildOidcLogoutUrl,
} from "@/lib/api/auth-redirect";
import { ensureAuthConfig } from "@/lib/api/auth-config";

function BetaClosedPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full space-y-4">
        <h1 className="text-2xl font-bold">Accès bêta non ouvert</h1>
        <p className="text-muted-foreground">
          SidonIAssist est en phase de test. Votre accès n&apos;est pas encore
          ouvert pour ce compte.
        </p>
        <p className="text-muted-foreground">
          Si vous pensez qu&apos;il s&apos;agit d&apos;une erreur, contactez
          votre administrateur.
        </p>
        <div className="flex flex-wrap gap-2">
          <Button
            nativeButton={false}
            render={
              <a href={buildOidcLoginUrlForPath("/")}>Réessayer la connexion</a>
            }
          />
          <Button
            nativeButton={false}
            render={<a href={buildOidcLogoutUrl()}>Se déconnecter</a>}
          />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_public/beta-closed")({
  beforeLoad: async () => {
    if (typeof window === "undefined") {
      return;
    }

    const config = await ensureAuthConfig();
    if (!config.betaAccessGateEnabled) {
      throw redirect({ to: "/" });
    }
  },
  component: BetaClosedPage,
});
